import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UpdatingTimeComponent } from './updating-time/updating-time.component';

@NgModule({
  imports: [CommonModule],
  declarations: [UpdatingTimeComponent],
  exports: [UpdatingTimeComponent],
})
export class UpdatingTimeModule {}
